/**
 * Labstep
 *
 * @module state/constants/notification
 * @desc Constants for Notification
 */

export const SET_ALL_NOTIFICATIONS_AS_VIEWED =
  'SET_ALL_NOTIFICATIONS_AS_VIEWED';
